import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const headerWithYearPicker = ({
  date,
  changeYear,
  // changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  startYear
}) => {
  let years;
  if (typeof startYear !== 'undefined' && startYear !== null) {
    const numberOfYears = startYear;
    const number = Number(numberOfYears) + 1;
    years = Array
      .from(
        { length: number },
        (current, index) => (new Date().getFullYear() - numberOfYears + index).toString()
      );
  } else {
    const numberOfYears = 5;
    years = Array
      .from(
        { length: numberOfYears * 2 + 1 },
        (current, index) => (new Date().getFullYear() - numberOfYears + index).toString()
      );
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 10px',
    }}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          decreaseMonth();
        }}
        disabled={prevMonthButtonDisabled}
        style={{
          border: 'none',
          background: 'none',
          color: 'inherit',
          padding: '3px',
          font: 'inherit',
          cursor: 'pointer',
          outline: 'inherit',
        }}
      >
        <div
          className="custom-picker-arrow"
          style={{
            borderWidth: '3px 0 0 3px',
            transform: 'rotate(-45deg)'
          }}
        />
      </button>
      <div
        className="react-datepicker__current-month"
        style={{
          display: 'flex',
          gap: '5px',
          alignItems: 'flex-end',
          lineHeight: '20px'
        }}
      >
        {moment(date).format('MMM')}
        <div className="dropdown" id="selectYearDropdown">
          <div
            className="btn btn-secondary dropdown-toggle"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown" aria-expanded="false"
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              padding: 0,
              fontSize: '0.944rem',
              height: '20px',
              fontWeight: 'bold'
            }}
          >
            {date.getFullYear()}
          </div>
          <ul
            className="dropdown-menu"
            aria-labelledby="dropdownMenuButton1"
            style={{
              overflowX: 'auto',
              maxHeight: '200px',
            }}
          >
            {years.map((year) => (
              <li key={year}>
                <a
                  role="button"
                  tabIndex={0}
                  className={year === date.getFullYear().toString() ? 'dropdown-item selected' : 'dropdown-item'}
                  onClick={() => {
                    changeYear(year);
                  }}
                >
                  {year}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <button
        onClick={(e) => {
          e.preventDefault();
          increaseMonth();
        }}
        disabled={nextMonthButtonDisabled}
        style={{
          border: 'none',
          background: 'none',
          color: 'inherit',
          padding: '3px',
          font: 'inherit',
          cursor: 'pointer',
          outline: 'inherit',
        }}
      >
        <div
          className="custom-picker-arrow"
          style={{
            borderWidth: '3px 3px 0 0',
            transform: 'rotate(45deg)'
          }}
        />
      </button>
    </div>
  );
};

function OptimizeDatePicker({ className, startYear, ...props }) {
  return (
    <DatePicker
      dateFormat="MM/dd/yyyy"
      calendarClassName="optimize-date-picker-calendar"
      className={`optimize-date-picker ${className}`}
      // renderCustomHeader={headerWithYearPicker}
      renderCustomHeader={(headerProps) => headerWithYearPicker({ ...headerProps, startYear })}
      popperModifiers={[
        {
          name: 'arrow',
          options: { padding: 24 },
        },
      ]}
      {...props}
    />
  );
}

export default OptimizeDatePicker;
